import { DEFAULT_CALENDAR_STRINGS } from '@fluentui/date-time-utilities';
export var defaultCalendarStrings = DEFAULT_CALENDAR_STRINGS;
/**
 * @deprecated Use `defaultCalendarStrings`
 */
export var defaultDayPickerStrings = defaultCalendarStrings;
export var defaultCalendarNavigationIcons = {
    leftNavigation: 'Up',
    rightNavigation: 'Down',
    closeIcon: 'CalculatorMultiply',
};
//# sourceMappingURL=defaults.js.map